import type { Appendable } from "../util/Appendable";
import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { clone } from "../util/Utils";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";
import { FacetValue } from "../filter/FacetValue";
import type { TrackingLabels } from "../tracking/TrackingLabels";

const TEMPLATE_ID = `heureka_ottoSwitchBannerTemplate`;
const SELECTOR_TEMPLATE = `#${TEMPLATE_ID}`;
const CLASS_BANNER = `heureka_ottoSwitchBanner`;
const SELECTOR_BANNER = `.${CLASS_BANNER}`;
const SELECTOR_TEMPLATE_BANNER = `${SELECTOR_TEMPLATE} ${SELECTOR_BANNER}`;
/*                                                         */

const SESSION_STORAGE_KEY = "heureka_ottoSwitchBannerDisabled";

export default class OttoSwitchBanner implements Appendable {
  static readonly factory = HeurekaElementFactory.byClass(CLASS_BANNER, OttoSwitchBanner);

  private facetValue: FacetValue | undefined;

  /*               */

  constructor(readonly banner: HTMLElement) {}

  /*                  */

  static fromTemplate(rootElement?: ParentNode | null): OttoSwitchBanner | undefined {
    return OttoSwitchBanner.factory.pick(SELECTOR_TEMPLATE_BANNER, rootElement);
  }

  /*               */

  private init() {
    const facetValue = FacetValue.fromId("facetValue_verkaeufer_otto");
    if (facetValue) {
      this.facetValue = facetValue;
    }

    if (this.facetValue) {
      /*                   */
      document.getElementById("find_facetValueTags")?.classList.add("find_facetValueTags--flexWidth");
      document.querySelector(".find_refinementBar")?.classList.add("find_refinementBar--wrap");

      this.banner.addEventListener("oc-close", () => this.onCloseClick());
      this.visible = !sessionStorage.getItem(SESSION_STORAGE_KEY);
    } else {
      this.visible = false; /*                   */
    }

    return this;
  }

  private onCloseClick() {
    this.visible = false;
    sessionStorage.setItem(SESSION_STORAGE_KEY, "true");
    /*                                   */
  }

  private onAcceptClick() {
    /*                                          */
    /*                                                  */
    /*                                                */
    /*                                                       */
    /*  */
  }

  /*                       */

  appendTo(elem: HTMLElement): void {
    elem.appendChild(this.banner);
  }

  clone() {
    return OttoSwitchBanner.factory.create(clone(this.banner)).init();
  }

  get visible(): boolean {
    return !this.banner.hidden && this.banner.childElementCount > 0;
  }

  set visible(visibility: boolean) {
    this.banner.hidden = !visibility;
  }

  /*                                             */
  /*                                                         */
  /**/

  /*       */

  private activityTracking(activity: TrackingLabels["san_FacetActivity"]) {
    eventQBus.emit("tracking.bct.submitEvent", {
      san_FacetActivity: activity,
      san_FacetActivityType: this.facetValue?.name,
    });
  }
}
